import { Spoller, addToGlobalThisRet } from "@plugins";
import jquery from "jquery";

const $ = jquery;

function initPopapAccordion() {
    new Spoller(".js-popap-accordion", {
        duration: 250,
        selectorToggleBtn: ".js-popap-accordion-toggle-btn",
        selectorContent: ".js-popap-accordion-text",
        makeToggleBtnActive: false,
    });
}

$(document).ajaxSuccess(() => {
    initPopapAccordion();
});

addToGlobalThisRet(initPopapAccordion, "initPopapAccordion");
